export default __webpack_public_path__ + "static/media/testimonialspro.dd0001f4.png";